export default "__VITE_ASSET__30a3c846__"